import React, { useState ,useEffect} from "react";
import AdminLayout from "../../Layout";
import {
  useGetAssignmentQuery,
  useGetCampusByNameQuery,
  useGetClustersByCampusQuery,
  useStudentsNotAttendedAssignmentQuery,
} from "../../../../graphql/generated.tsx";
import { useParams, useLocation } from "react-router-dom";
import fileDownload from "js-file-download";
import { Table } from "flowbite-react";
import ReactSelect from "react-select";
import { SkeletonRow } from "../../../Student/Components/LeaderBoardSkeleton.jsx";
import { IoMdArrowRoundBack } from "react-icons/io";
import { FaDownload } from "react-icons/fa6";
import { MdTableChart } from "react-icons/md";
import Loader from "../../../../components/Loader.jsx";

const clusterSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 40,
    borderRadius: 6,
    borderColor: "#d1d5db",
    backgroundColor: "#ffffff",
    boxShadow: state.isFocused ? "0 0 0 1px #9ca3af" : "none",
    "&:hover": {
      borderColor: "#9ca3af",
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "2px 8px",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#111827",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#d1d5db"
      : state.isFocused
      ? "#f3f4f6"
      : "#ffffff",
    color: "#111827",
    ":active": {
      backgroundColor: "#d1d5db",
    },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 30,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 60,
  }),
};

const AssignmentNotAttendee = () => {
  const { campusName, assignment_id } = useParams();
  const location = useLocation();
  const { assignmentClusterIds, assignmentClusterNames, assignmentName } = location.state || {};
  const [selectedCluster, setSelectedCluster] = useState();
  const [showDownloadDropdown, setShowDownloadDropdown] = useState(false);
   const [Isload, setIsload] = useState(true);

   useEffect(()=>{
    setTimeout(()=>{
      setIsload(false);
    },2000);
  },[]);

  const { data: campus, loading: campusLoading } = useGetCampusByNameQuery({
    variables: { name: campusName },
  });
  const { data: Assignment } = useGetAssignmentQuery({
    variables: { id: assignment_id },
  });

  const { data, loading, refetch } = useStudentsNotAttendedAssignmentQuery({
    variables: {
      campus_id: campus?.getCampusByName.id,
      assignmentId: assignment_id,
      cluster_id: selectedCluster,
    },
    skip: !campus,
  });

  const { data: clusters, loading: clusterLoading } =
    useGetClustersByCampusQuery({
      variables: { campusName: campusName, limit : 200 },
      skip: campusLoading,
    });

  // Auto-select first cluster from assignment when navigating from AssignmentReport
  useEffect(() => {
    if (assignmentClusterIds?.length > 0) {
      setSelectedCluster(assignmentClusterIds[0]);
    }
  }, [assignmentClusterIds]);

  const students = data?.studentsNotAttendedAssignment || [];

  const handleClusterChange = (e) => {
    const clusterId = e;
    setSelectedCluster(clusterId);
    refetch({ cluster_id: clusterId });
  };

  const clusterFilterOptions = [
    { value: "", label: "Whole Campus" },
    ...(clusters?.getClustersByCampus || []).map((cluster) => ({
      value: cluster.id,
      label: cluster.name,
    })),
  ];

  const handleDownloadCSV = () => {
    const csvContent = [
      ["Name", "Email", "Roll No", "Department", "Cluster Name"],
      ...students.map((student) => [
        student.student_name,
        student.student_email,
        student.student_rollno,
        student.student_department && String(student.student_department).trim() !== "" ? student.student_department : "-",
        student.cluster_names,
      ]),
    ]
      .map((row) => row.join(","))
      .join("\n");

    fileDownload(
      csvContent,
      `students-not-attended ${Assignment?.getAssignment.name}.csv`
    );
  };

  return (
    <AdminLayout>
      <div className="container p-8 mx-auto">
        {/* Combined Card for Header, Filters, and Table */}
        <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
          {/* Header Section */}
          <div className="relative flex flex-col justify-between w-full p-6 pb-5 border-b sm:flex-row">
            <div className="flex items-center mb-5 sm:mb-0">
              <button
                onClick={() => window.history.back()}
                className="text-gray-500 hover:text-gray-700 focus:outline-none"
              >
                <IoMdArrowRoundBack className="w-6 h-6" />
              </button>
              <h1 className="ml-2 text-2xl font-bold max-md:text-lg">
                {Assignment?.getAssignment.name}
              </h1>
            </div>
            <p>
              <span className="font-bold">Non Participants Count: </span>
              {students.length}
            </p>
          </div>

          {/* Filters Section */}
          <div className="flex items-center justify-between w-full px-6 py-4 border-b">
            <div className="w-full md:w-56">
              <label
                htmlFor="cluster-filter"
                className="block mb-1 text-sm font-semibold text-gray-600"
              >
                Batch details
              </label>
              <ReactSelect
                inputId="cluster-filter"
                isSearchable={false}
                options={clusterFilterOptions}
                value={clusterFilterOptions.find((option) => option.value === (selectedCluster || "")) || clusterFilterOptions[0]}
                onChange={(option) => handleClusterChange(option?.value || "")}
                styles={clusterSelectStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                menuShouldScrollIntoView
                disabled={clusterLoading || campusLoading}
              />
            </div>
            <div className="relative">
              <button
                onClick={() => setShowDownloadDropdown((prev) => !prev)}
                className="inline-flex items-center justify-center w-9 h-9 text-slate-600 transition-all hover:text-slate-900 focus:outline-none"
                title="Download"
                aria-label="Download"
              >
                <FaDownload size={20} />
              </button>

              {showDownloadDropdown && (
                <div className="absolute top-0 right-[calc(100%+10px)] z-20 w-[165px] rounded-2xl border border-slate-200 bg-white p-2 shadow-[0_10px_24px_rgba(2,6,23,0.08)]">
                  <p className="mb-2 px-2 text-[11px] font-semibold tracking-wide text-slate-500 uppercase">
                    Choose format
                  </p>
                  <button
                    onClick={() => {
                      handleDownloadCSV();
                      setShowDownloadDropdown(false);
                    }}
                    className="flex w-full items-center gap-2.5 rounded-xl px-2.5 py-2 text-left text-slate-700 transition-colors hover:bg-slate-100"
                  >
                    <span className="rounded-lg bg-slate-100 p-1.5 text-slate-600">
                      <MdTableChart size={17} />
                    </span>
                    <span className="text-sm font-medium">CSV</span>
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Table Section */}
          <div className="overflow-x-auto">
            <Table striped hoverable className="min-w-full">
              <Table.Head style={{backgroundColor: '#5c7a94'}}>
                <Table.HeadCell style={{backgroundColor: '#5c7a94'}} className="px-2 py-1.5 text-[10px] text-center text-white sm:px-3 sm:py-2 sm:text-xs">Name</Table.HeadCell>
                <Table.HeadCell style={{backgroundColor: '#5c7a94'}} className="px-2 py-1.5 text-[10px] text-center text-white sm:px-3 sm:py-2 sm:text-xs">Email</Table.HeadCell>
                <Table.HeadCell style={{backgroundColor: '#5c7a94'}} className="px-2 py-1.5 text-[10px] text-center text-white sm:px-3 sm:py-2 sm:text-xs">Roll No</Table.HeadCell>
                <Table.HeadCell style={{backgroundColor: '#5c7a94'}} className="px-2 py-1.5 text-[10px] text-center text-white sm:px-3 sm:py-2 sm:text-xs">Cluster Names</Table.HeadCell>
              </Table.Head>
              <Table.Body>
                {loading || campusLoading || clusterLoading || Isload ? (
                  <>
                    <SkeletonRow col={4} />
                    <SkeletonRow col={4} />
                    <SkeletonRow col={4} />
                    <SkeletonRow col={4} />
                  </>
                ) : students.length === 0 ? (
                  <Table.Row>
                    <Table.Cell colSpan={4} className="py-6 text-center text-gray-500">
                      No students found.
                    </Table.Cell>
                  </Table.Row>
                ) : (
                  students.map((student) => (
                    <Table.Row
                      key={student.student_id}
                      className="hover:bg-gray-50"
                    >
                      <Table.Cell className="text-center">{student.student_name}</Table.Cell>
                      <Table.Cell className="text-center">{student.student_email}</Table.Cell>
                      <Table.Cell className="text-center">{student.student_rollno}</Table.Cell>
                      <Table.Cell className="text-center">{student.cluster_names}</Table.Cell>
                    </Table.Row>
                  ))
                )}
              </Table.Body>
            </Table>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AssignmentNotAttendee;
